module.exports = __webpack_public_path__ + "img/gallery-tick.df240b0d.svg";